import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { compressorIsInstalled, compressorNameOrNumber,
	compressorStatusImage, compressorOnMotorImage,
	compressorOnLoadImage, compressorDisplayedStateTNR } from "../model/Kompressor";
import AlmigProgressBar from "../grundelemente/AlmigProgressBar";
import "./VerbundKompressor.css";

const genOnLoadFactor = compressor => (
	compressor.load_factor_percent > 0
		? <AlmigProgressBar value={compressor.load_factor_percent} />
		: <div />
);

const genInstalledStatus = compressor => (
	compressorIsInstalled(compressor) &&
	<div>
		{ compressorOnMotorImage(compressor) }
		{ compressorOnLoadImage(compressor) }
		<center>
			<FormattedMessage id={compressorDisplayedStateTNR(compressor)} />
		</center>
		{ genOnLoadFactor(compressor) }
	</div>
);

const VerbundKompressor = props => (
	<div className="VerbundKompressor" onDoubleClick={() => {
		if (compressorIsInstalled(props.compressor)) {
			props.gotoCompressor(props.location_path);
		}}}>
		<center>{ compressorNameOrNumber(props.compressor) }</center>
		{ compressorStatusImage(props.compressor) }
		{ genInstalledStatus(props.compressor) }
	</div>
);

VerbundKompressor.propTypes = {
	location_path: PropTypes.string.isRequired,
	compressor: PropTypes.object.isRequired,
	gotoCompressor: PropTypes.func.isRequired
};

export default VerbundKompressor;
